import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertRoleRequest } from './types/upsert-role-request.type';

/**
 * Creates or updates a role.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param body - The role payload (omit `uid` to create).
 * @returns OperationResultWithData wrapping the uid of the upserted role.
 */
export const upsertRole = async (instance: KyInstance, body: UpsertRoleRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<string>>(Uri.roles.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
